var _path, _defs, _animateTransform;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0.666504C49.6731 0.666504 64 14.9934 64 32.6665C64 50.3396 49.6731 64.6665 32 64.6665C14.3269 64.6665 0 50.3396 0 32.6665C0 14.9934 14.3269 0.666504 32 0.666504ZM32 58.2665C46.1385 58.2665 57.6 46.805 57.6 32.6665C57.6 18.528 46.1385 7.06651 32 7.06651C17.8615 7.06651 6.4 18.528 6.4 32.6665C6.4 46.805 17.8615 58.2665 32 58.2665Z",
    fill: "url(#paint0_linear_1883_7623)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1883_7623",
    x1: -7.45422e-9,
    y1: 32.6665,
    x2: 55,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#577DF7",
    stopOpacity: 0
  })))), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    from: "0 0 0",
    to: "360 0 0",
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1300ms"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.7c15d57b21f2ae34c0d34547c419db78.svg";
export { ForwardRef as ReactComponent };